export default {"src":"/_next/static/media/r.1ab89786.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};